module.exports = __webpack_public_path__ + "static/media/400114_02.79f9eac0.png";